import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {listOfBank} from "../Quickbet/helpers/quickbetHelper";
import './BritePayments.css';
interface BPProps {
    initBrite?: () => void;
    makeMarketVisible?: () => void;
    styles: any
    conditions?: any
}
const BritePayments:FC <BPProps> = ({initBrite, styles, makeMarketVisible, conditions}) => {
    const { t } = useTranslation();
    const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
    return (
        <div className='brite-wrapper card-rounded position-relative card-px rounded' style={{border: `1px solid ${styles.colors.fontColor}`}}>
            <div className="card-body p-3">
                <h2
                    className='text-center rounded title p-1'
                    style={{
                        color: styles.colors.fontTitleColor,
                        fontSize: styles.fonts.titleFontSize,
                        fontFamily: styles.fonts.titleFontFamily,
                        backgroundColor: styles.colors.blockTitleBgColor,
                        textTransform: 'uppercase'
                    }}
                >
                    {t('brite.title')}
                    <img className='brite-logo' src={toAbsoluteUrl('/assets/img/brite/brite.svg')} alt="brite"/>
                </h2>
                <div className='text-center' style={{color: styles.colors.fontColor}}>
                    {t('brite.clickToPayTitle')}
                </div>
                <div className='text-center' style={{color: styles.colors.fontColor}}>
                    {t('brite.paymentHintTitle')}
                </div>
                {
                    conditions && conditions !== undefined && Object.keys(conditions).length > 0 ?
                        <button
                            onClick={initBrite}
                            disabled={conditions.total_odds < conditions.minTicketOdds}
                            style={{
                                backgroundColor: '#f7ff99',
                                color: '#000',
                                fontSize: styles.fonts.buttonFontSize,
                                fontFamily: styles.fonts.titleFontFamily,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                width: '80%',
                                margin: '0 auto',
                            }}
                            className='btn mt-2 brite-init p-2'
                        >
                            {t('brite.playNow')}
                        </button>
                        : <button
                            onClick={initBrite}
                            style={{
                                backgroundColor: '#f7ff99',
                                color: '#000',
                                fontSize: styles.fonts.buttonFontSize,
                                fontFamily: styles.fonts.titleFontFamily,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                width: '80%',
                                margin: '0 auto',
                            }}
                            className='btn mt-2 brite-init p-2'
                        >
                            {t('brite.playNow')}
                        </button>
                }
                {
                    conditions && conditions.total_odds < conditions.minTicketOdds ? (
                        <div style={{ color: 'red' }}>
                            {t('notifications.notEnoughOdds')}
                        </div>
                    ) : null
                }

                <div className="hint-wrapper">
                    <div className="hint-item" style={{color: styles.colors.fontColor}}>
                        <i
                            className="fas fa-bolt"
                            style={{
                                border: `1px solid ${styles.colors.fontColor}`,
                                borderRadius: '5px',
                                padding: '5px',
                                marginRight: '10px',
                                color: styles.colors.fontColor
                            }}
                        />
                        {t('brite.usingBank')}
                    </div>
                    <div className="hint-item" style={{color: styles.colors.fontColor}}>
                        <i
                            className="fa-solid fa-fingerprint"
                            style={{
                                border: `1px solid ${styles.colors.fontColor}`,
                                borderRadius: '5px',
                                padding: '5px',
                                marginRight: '10px',
                                color: styles.colors.fontColor
                            }}
                        />
                        {t('brite.secure')}
                    </div>
                </div>
                <div>
                    <ul className='bank-list'>
                        {listOfBank.map((item: string, index: number) => (
                            <li key={index}>
                                <img
                                    src={toAbsoluteUrl(`/assets/img/brite/${item}.svg`)}
                                    alt={item}
                                />
                            </li>
                        ))}
                    </ul>

                </div>
                {
                    makeMarketVisible ?
                        <p
                            className="mt-3 text-center fs-6"
                            onClick={makeMarketVisible}
                        >
                            {t('quickbet.priceBlock.changeBet')}
                        </p>
                        : null
                }
            </div>
        </div>
    )
};

export default BritePayments;